export default __webpack_public_path__ + "static/media/Jenny_Timur-521_websize_tn.2f22b12f.jpg";